<div class="layout">
  <div class="mapa">
    <app-mapa-creador-mapbox
      [dibujar]="['LineString', 'Point']"
      [lineString]="lineString"
      (lineStringChange)="onLineStringChange($event)"
      [points]="points"
      (pointsChange)="onPointsChange($event)"
      [checkDistanceFromLineString]="true"
      [pointLabel]="'Parada'"
      [indicaciones]="indicaciones"
      [polygons]="terminalesMapa"
    ></app-mapa-creador-mapbox>
  </div>

  <div class="paradas">
    <!-- Paradas: se ordenan arrastrando -->
    <section class="panel">
      <div class="panel-titulo">
        <span>Paradas</span>
        <span class="panel-contador">{{ paradas.length }}</span>
      </div>

      <div
        class="lista-paradas"
        cdkDropList
        (cdkDropListDropped)="drop($event)"
        [cdkDropListData]="paradas"
      >
        @for (p of paradas; track p._id; let i = $index) {
          <div cdkDrag class="drag-item">
            <div class="drag-placeholder" *cdkDragPlaceholder></div>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="handle">drag_indicator</mat-icon>
                  <span class="parada-nombre">{{ p.nombre }}</span>
                </mat-panel-title>
                <mat-panel-description>
                  <button
                    irxBotonIcono
                    type="button"
                    (click)="removeParada(p)"
                    tooltip="Eliminar parada"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div class="campos-parada">
                <mat-form-field subscriptSizing="dynamic">
                  <mat-label>Nombre</mat-label>
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="p.nombre"
                    autocomplete="off"
                  />
                </mat-form-field>

                <ng-select
                  [items]="tipoParada"
                  [(ngModel)]="p.tipo"
                  placeholder="Tipo"
                  [clearable]="false"
                  appendTo="body"
                  notFoundText="Sin resultados"
                  (change)="onTipoParadaChange($event, p._id)"
                ></ng-select>

                <mat-form-field subscriptSizing="dynamic">
                  <mat-label>Destino</mat-label>
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="p.destino"
                    autocomplete="off"
                  />
                </mat-form-field>

                <mat-form-field subscriptSizing="dynamic">
                  <mat-label>Por</mat-label>
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="p.por"
                    autocomplete="off"
                  />
                </mat-form-field>

                <div class="checks-parada">
                  <mat-checkbox color="primary" [(ngModel)]="p.subida">
                    Subida
                  </mat-checkbox>
                  <mat-checkbox color="primary" [(ngModel)]="p.bajada">
                    Bajada
                  </mat-checkbox>
                </div>
              </div>
            </mat-expansion-panel>
          </div>
        } @empty {
          <span class="no-info">Marcá las paradas en el mapa</span>
        }
      </div>
    </section>

    <!-- Importar el trazado desde los reportes de un colectivo -->
    <section class="panel">
      <div class="panel-titulo">
        <span>Importar recorrido</span>
      </div>

      <div class="campos-importar">
        <ng-select
          [items]="colectivos"
          bindLabel="identificacion"
          [(ngModel)]="colectivo"
          placeholder="Colectivo"
          appendTo="body"
          notFoundText="Sin resultados"
        ></ng-select>

        <app-date-range-selector
          [(dateRange)]="dateRange"
          (dateRangeChange)="onDateRangeChange()"
        ></app-date-range-selector>

        @if (reportes.length > 0) {
          <div class="reportes">
            <div class="reportes-datos">
              <span>Reportes: {{ reportes.length }}</span>
              <span>Desde: {{ min }}</span>
              <span>Hasta: {{ max }}</span>
            </div>

            <mat-slider
              max="{{ reportes.length - 1 }}"
              min="0"
              color="primary"
              style="width: 100%"
            >
              <input
                matSliderStartThumb
                [(value)]="min"
                (valueChange)="onChangeSlider()"
              />
              <input
                matSliderEndThumb
                [(value)]="max"
                (valueChange)="onChangeSlider()"
              />
            </mat-slider>
          </div>
        }
      </div>
    </section>
  </div>
</div>
